<style lang="less" scoped>
  .sidebar {
    max-width: 320px;
  }
</style>
<template>
  <div
    id="menu"
    class="column sidebar"
  >
    <search @search="search" />
    <div
      v-show="currentUser.isImpersonated"
      class="column is-12 is-paddingless"
    >
      <div
        class="card card-user"
        style="padding-left:10px;background-color:darkred;color:#F8F8F8"
      >
        Impersonating
      </div>
    </div>
    <current-user-info
      v-if="currentUser.user"
      ref="info"
      :user="currentUser.user"
      :token="currentUser.token"
      :badge="badge"
      @logout="logout"
      @updateProfilePicture="updateProfilePicture"
    />
    <div
      v-if="!currentUser.user"
      class="column is-12"
    >
      <div class="buttons is-flex">
        <div class="control">
          <router-link
            to="/login"
            class="button is-dark"
          >
            Login
          </router-link>
        </div>
        <div class="control">
          <router-link
            to="/join"
            class="button is-dark"
          >
            Signup
          </router-link>
        </div>
      </div>
    </div>
    <member-links :user="currentUser.user" />
    <!--<point-calculator></point-calculator>-->
    <mq-layout mq="tablet+">
      <!--<instagram />-->
    </mq-layout>
  </div>
</template>

<script>
  import MemberLinks from './MemberLinks.vue'
  import Search from './Search.vue'
  import Instagram from './Instagram.vue'
  import PointCalculator from './PointCalculator.vue'
  import CurrentUserInfo from './CurrentUserInfo.vue'
  import SignupUser from '../auth/SignupUser.vue'

  export default {
    name: 'Sidebar',
    components: {
      MemberLinks,
      Search,
      Instagram,
      PointCalculator,
      CurrentUserInfo,
      SignupUser
    },
    props: ['currentUser', 'badge'],
    data () {
      return {
        isOpen: true,
        showJoinEmailDialog: false,
      }
    },
    mounted () {
      if (window.innerWidth <= 1024) {
        setTimeout(() => {
          window.scrollTo(0, this.$refs.info.$el.clientHeight)
        }, 50)
      }
    },
    methods: {
      showJoinEmail() {
        this.cctHTML = this.$refs.cctInlineForm.innerHTML;
        this.showJoinEmailDialog = true
      },
      logout () {
        this.$emit('logout')
      },
      search (value) {
        this.$emit('search', value)
      },
      updateProfilePicture () {
        this.$emit('updateProfilePicture')
      }
    }
  }
</script>
